export default [
    {
      path: "/card",
      name: "Card",
      meta: {
        title: "卡券兑换",
        keepAlive: true,
        footer: true,
        auth: true
      },
      component: () => import("@views/card/Index.vue")
    },
];  